<button
  [disabled]="disabled"
  (click)="onHandleClick()"
  type="button"
  class="bo-button"
  [ngClass]="extraClasses"
>
  {{ text | translate }}
</button>
